/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Free_NoteInputs */



/**
* | output |
* | --- |
* | "Free forever, no card needed" |
*
* @param {Signup_Free_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_free_note = /** @type {((inputs?: Signup_Free_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Free_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gratuit pour toujours, sans carte bancaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dauerhaft kostenlos, keine Karte nötig")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gratis per sempre, nessuna carta richiesta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Бесплатно навсегда, карта не нужна")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gratis para siempre, sin tarjeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("永久免费，无需银行卡")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ずっと無料、カード不要")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हमेशा मुफ़्त, कार्ड की ज़रूरत नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gratuito para sempre, sem cartão")
	return /** @type {LocalizedString} */ ("Free forever, no card needed")
});